import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiEndpoints } from '@core/constants';
import { ApiResponse, PendingApproval, SearchRequestParam, UserApproveRejectRequest } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class ApprovalQueueService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
 
  getPendingApprovalInfo(searchRequestParam: SearchRequestParam): Observable<PendingApproval[]> {
    return this.http.post<PendingApproval[]>(ApiEndpoints.getPendingApprovalUsers, searchRequestParam)
      .pipe(
        catchError(this.handleError<PendingApproval[]>('getPendingApprovalInfo', []))
      );
  }

  postUserApproveOrReject(request: UserApproveRejectRequest[]): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(ApiEndpoints.postUserApproveOrReject, request)
      .pipe(
        catchError(this.handleError<ApiResponse>('userApproveOrReject', null))
      );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
